import { initializeAppState } from "../../../../../../common/appState";
import { clearLocalStorageData } from "../progressManager";

export async function logout(shouldNotRemountMain?: boolean) {
    const promise = fetch("api/Auth/Logout", {
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        credentials: "include",
    });

    initializeAppState(
        "user",
        "relatedUsers",
        "items",
        "xpBeforeSignUp",
        "unreadMessages",
        "questState",
        "isDailyBonusUnclaimed",
        "xpBoostRemainingSeconds",
        "lastUsedXpBooster",
        "unreadComments",
        "invitationBonusList",
        "authorPanelState",
        "otherUserPanelsState",
        "messagePanelState",
        "vocabRoulettePanelState",
        "shopPanelState",
        "paymentPanelState",
        "activeUsersPanelState",
        "socialPanelState",
        "imageDetailPanelState",
        "invitationCardPanelState",
        "simpleDialogState",
        "guestUserXpDialogState",
        "registeredUserXpDialogState",
        "friendsLimitDialogState",
        "guestMessageLimitDialogState",
        "addCoinsDialogState"
    );
    clearLocalStorageData(shouldNotRemountMain);

    await promise; // No need to return. Just wait.
}
